import React, { useMemo, useState } from "react";
import Accordion from "../../../components/accordian";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import VehicleForm from "./VehicleForm";
import { ParkingStickerVehicle } from "../../../constants/common";
import { useGetAllPlateLetters, useGetAllPlateSource } from "../../../hooks/common/query";
import { mapToOptions } from "../../../lib/functions";
import EntryStickerForParkingVehiclesTable from "../../../components/table/EntryStickerForParkingVehiclesTable";
import { Button } from "../../../components/button";

interface VehicleInformationProps {
  addedVehicles: ParkingStickerVehicle[];
  setAddedVehicles: React.Dispatch<React.SetStateAction<ParkingStickerVehicle[]>>;
  isFieldsDisabled: boolean;
}

const VehicleInformation = ({
  addedVehicles,
  setAddedVehicles,
  isFieldsDisabled = false,
}: VehicleInformationProps) => {
  const [selectedKey, setSelectedKey] = useState<string>("1");

  const { t } = useTranslation();

  const { data: allPlateSource } = useGetAllPlateSource();

  const plateSource = useMemo(
    () =>
      mapToOptions("s_Desc_E", "s_Desc_A", "n_DetailedCode", allPlateSource),
    [allPlateSource]
  );

  const { data: allPlateLetters } = useGetAllPlateLetters();

  const plateLetters = useMemo(
    () =>
      mapToOptions("s_Desc_E", "s_Desc_A", "n_DetailedCode", allPlateLetters),
    [allPlateLetters]
  );

  const [isAddVehicleFormVisible, setIsAddVehicleFormVisible] =
    useState<boolean>(true);

  const [editingVehicle, setEditingVehicle] = useState<ParkingStickerVehicle | null>(null);

  const handleFormReset = () => {
    setIsAddVehicleFormVisible(false);
    setEditingVehicle(null);
  };

  return (
    <div className="bg-white p-2 md:p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
      <Accordion
        selectedKey={selectedKey}
        onSelectionChange={setSelectedKey}
        title={
          <h1 className="text-xl md:text-2xl flex flex-1 items-end -mt-2">
            {t("3")}. {t("vehicleInformation")}
          </h1>
        }
      >
        {!isFieldsDisabled && (
          <div className="flex justify-end">
            <Button
              type="button"
              onClick={() => {
                setIsAddVehicleFormVisible(false);
                setEditingVehicle(null);
                setTimeout(() => {
                  setIsAddVehicleFormVisible(true);
                }, 0);
              }}
              Icon={<Plus size={20} />}
            >
              {t("addVehicle")}
            </Button>
          </div>
        )}

        <EntryStickerForParkingVehiclesTable
          addedVehicles={addedVehicles}
          setAddedVehicles={setAddedVehicles}
          setEditingVehicle={setEditingVehicle}
          setIsAddVehicleFormVisible={setIsAddVehicleFormVisible}
          onFormReset={handleFormReset}
          plateSource={plateSource}
          plateLetters={plateLetters}
          isFieldsDisabled={isFieldsDisabled}
        />

        {isAddVehicleFormVisible && (
          <VehicleForm
            isFieldsDisabled={isFieldsDisabled}
            setIsAddVehicleFormVisible={setIsAddVehicleFormVisible}
            setAddedVehicles={setAddedVehicles}
            editingVehicle={editingVehicle}
            setEditingVehicle={setEditingVehicle}
            plateSource={plateSource}
            plateLetters={plateLetters}
          />
        )}
      </Accordion>
    </div>
  );
};

export default React.memo(VehicleInformation);
